import React from 'react';
import { SpinnerWithText } from '../../decorated-elements';
import './AppLoadingSpinner.css';

const AppLoadingSpinner: React.SFC<{ loadingText: string }> = ({
  loadingText
}) => (
  <div className="app-root_first-boot-loader">
    <div className="app-root_first-boot-loader_spinner-wrapper">
      <SpinnerWithText size="md">
        <span className="app-root_first-boot-loader_app-name">
          {loadingText}
        </span>
      </SpinnerWithText>
    </div>
  </div>
);

export default AppLoadingSpinner;
